<template>
  <input
    class="form-control w-full"
    :type="type"
    :id="id"
    :value="value"
    :placeholder="placeholder"
    :autocomplete="autoComplete"
    :autocorrect="autoCorrect"
    :autocapitalize="autoCapitalize"
    :spellcheck="spellcheck"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  name: "FormInput",
  props: {
    type: {
      type: String,
      default: "text",
    },
    id: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Number],
      default: ""
    },
    placeholder: {
      type: String,
      default: "Type something..."
    },
    autoComplete: {
      type: String,
      default: "off"
    },
    autoCorrect: {
      type: String,
      default: "off"
    },
    autoCapitalize: {
      type: String,
      default: "off"
    },
    spellcheck: {
      type: Boolean,
      default: false
    },
  }
}
</script>